import { get } from '..';

const getSupportedVersions = () => get('button/system-config/APP_COMPATIBILITY');

export default getSupportedVersions;
